
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar, Space } from 'antd';
import {
  // LockOutlined,
  LogoutOutlined
} from '@ant-design/icons';
import { observer } from 'mobx-react-lite';
import { FormattedMessage } from 'react-intl';
import avatar from '@/assets/images/avatar.png';
import HeaderDropdown from '../HeaderDropdown';

const AvatarDropdown = observer(({ store }: any) => {
  const navigate = useNavigate();

  const handleClick = React.useCallback((evt: any) => {
    const { key } = evt;
    if (key === 'logout') {
      store.logout().then(() => {
        navigate('/User/login');
      });
      return;
    }

    if (key === 'changePwd') {
      navigate('/changePwd');
      return;
    }
  }, []);

  return (
    <HeaderDropdown
      menu={{
        items: [
          {
            key: 'logout',
            label: (
              <>
                <LogoutOutlined />&nbsp;
                <FormattedMessage id="common.Logout" defaultMessage="登出" />
              </>
            ),
          }
        ],
        onClick: handleClick
      }}
    >
      <Space className="action">
        <Avatar size="small" alt="avatar" src={avatar} />
        {store.config.customerName ?? ''}
      </Space>
    </HeaderDropdown>
  );
});

export default AvatarDropdown;
